import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AudioPlayerModule } from 'src/app/common-components/audio-player/audio-player.module';
import { CallDetailDialogModule } from 'src/app/common-components/call-details-dialog/call-detail-dialog.module';
import { CallHistoryFilterModule } from 'src/app/common-components/call-history-filters/call-history-filter.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { DurationFormatPipeModule } from 'src/app/pipes/duration-format-pipe/duration-format-pipe.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { FormatSecondsPipeModule } from 'src/app/pipes/format-seconds/format-seconds-pipe.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { PhoneRegisterModule } from '../phones/phone-register/phone-register.module';
import { CallLogsRegisterComponent } from './containers/call-logs-register.component';
import { CallLogsRegisterEffects } from './state/call-logs-register.effects';
import { callLogsRegisterFeatureKey, callLogsRegisterReducer } from './state/call-logs-register.reducer';
import { CallLogsRegisterViewComponent } from './views/call-logs-register-view.component';

@NgModule({
   declarations: [CallLogsRegisterComponent, CallLogsRegisterViewComponent],
   exports: [CallLogsRegisterComponent],
   imports: [
      AddSpacesPipeModule,
      FormatPhoneNumbersPipeModule,
      FormatSecondsPipeModule,
      CommonModule,
      DurationFormatPipeModule,
      FormsModule,
      CallHistoryFilterModule,
      MatNativeDateModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      RegisterModule,
      MatFormFieldModule,
      MatDatepickerModule,
      FormsModule,
      ReactiveFormsModule,
      MatNativeDateModule,
      MatDialogModule,
      MatInputModule,
      CallDetailDialogModule,
      MatTooltipModule,
      MatIconModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      RouterModule,
      MatMenuModule,
      ScrollingModule,
      RegisterModule,
      PhoneRegisterModule,
      AudioPlayerModule,
      EffectsModule.forFeature([CallLogsRegisterEffects]),
      StoreModule.forFeature(callLogsRegisterFeatureKey, callLogsRegisterReducer),
   ],
})
export class CallLogsRegisterModule {}
